import Vue from 'vue'
import Router from 'vue-router'
import { store } from '../vuex'

import Home       from '@/components/Home'
import Entrar     from "@/components/Entrar"
import Cadastro   from "@/components/Cadastro"
import Counter    from "@/components/Counter"
import Produtos   from "@/components/Produtos"
import Produto    from "@/components/Produto"
import Carrinho   from "@/components/Carrinho"
import Sucesso    from "@/components/Sucesso"
import Compras    from "@/components/Compras"
import AddSuccess from "@/components/AddSuccess"


Vue.use(Router)

const routes = [
    {
        name: 'home',
        path: '/',
        component: Home,
        meta: { title: 'Home', requiresLogin: false }
    },
    {
        name: 'entrar',
        path: '/entrar',
        component: Entrar,
        meta: { title: 'Acesso', requiresLogin: false }
    },
    {
        name: 'cadastro',
        path: '/cadastro',
        component: Cadastro,
        meta: { title: 'Cadastro', requiresLogin: false }
    },
    {
        name: 'counter',
        path: '/counter',
        component: Counter
    },
    {
        name: 'produtos',
        path: '/produtos',
        component: Produtos,
        meta: { title: 'Produtos', requiresLogin: true}
    },
    {
        name: 'produto',
        path: '/produto/:id',
        component: Produto,
        meta: { title: 'Adiciona íten(s) no meu carinho', requiresLogin: true }
    },
    {
        name: 'carrinho',
        path: '/carrinho',
        component: Carrinho,
        meta: { title: 'Carrinho', requiresLogin: true }
    },
    {
        name: 'sucesso',
        path: '/sucesso',
        component: Sucesso,
        meta: { title: 'Sua compra foi realizada com sucesso', requiresLogin: true }
    },
    {
        name: 'compras',
        path: '/compras',
        component: Compras,
        meta: { title: 'Minhas compra', requiresLogin: true }
    },
    {
        name: 'add_success',
        path: '/produto-adicionado-com-sucesso',
        component: AddSuccess,
        meta: { title: 'O produto foi adicionado no carrinho de compras', requiresLogin: true }
    }
]

/*Router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresLogin)) {
        // You can use store variable here to access globalError or commit mutation
        next("/Login")
    } else {
        next()
    }
})*/



const router = new Router({ routes })
router.beforeEach((to, from, next) => {

    document.title = to.meta.title;

    //if (to.name !== 'entrar' && !store.state.logged) next({ name: 'entrar' })

    if ((to.matched.some(record => record.meta.requiresLogin)) && (!store.state.logged))
        next({ name: 'entrar' })
    else
        next()
})

export default router
